export default {
    state: {
        isShare: false
    },
    mutations: {
        setIsShare(state, isShare = false) {
            state.isShare = isShare;
        }
    }
}